<template>
    <div class="app">
        <AppHeader fixed>
            <div class="container">
                <a class="navbar-brand" :href="site_url">
                    <img src="/img/brand/logo-big.png" width="120" height="35" alt="" />
                </a>

                <b-navbar-nav class="ml-auto">
                    <DefaultHeaderLanguage></DefaultHeaderLanguage>
                    <b-nav-item href="/login">{{ $t('common.login') }}</b-nav-item>
                </b-navbar-nav>
            </div>
        </AppHeader>

        <div class="app-body">
            <main class="main">
                <div class="main-container">
                    <router-view></router-view>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import { Header as AppHeader } from '@coreui/vue';
    import DefaultHeaderLanguage from '@/front/shared/views/layouts/partials/DefaultHeaderLanguage';
    import global from '@/front/shared/global';

    export default {
        name: 'GuestLayout',
        components: {
            DefaultHeaderLanguage,
            AppHeader,
        },
        data() {
            return {
                site_url: global.site_url,
            };
        },
    };
</script>
